// Each enum value IS the DigitalCard field name being flagged — this is what the mobile
// app reads to know which specific field to prompt the user to redo.
export enum DigitalCardChangeCategory {
    introMessage = 'cardMessage',
    photos = 'generatedImageUrl',
}
